/* import __COLOCATED_TEMPLATE__ from './upgrade.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();